var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 135",
    width: 136,
    height: 135,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1ece68}.b{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m135.7 67.4c0 37.3-30.3 67.5-67.5 67.5-37.3 0-67.5-30.2-67.5-67.5 0-37.2 30.2-67.5 67.5-67.5 37.2 0 67.5 30.3 67.5 67.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m113.2 66.1c0 23.6-19.3 42.8-42.9 42.8q0 0 0 0c-7.1 0-14.2-1.8-20.4-5.2l-22.7 5.9 6-22.1c-3.7-6.5-5.7-13.9-5.7-21.4 0-23.6 19.2-42.8 42.8-42.8 11.5 0 22.3 4.4 30.3 12.5 8.1 8.1 12.6 18.9 12.6 30.3zm-7.3 0c0-9.5-3.7-18.5-10.4-25.2-6.7-6.7-15.6-10.4-25.1-10.4-19.7 0-35.6 15.9-35.6 35.6 0 6.7 1.8 13.2 5.4 18.9l0.8 1.3-3.6 13.2 13.5-3.6 1.3 0.8c5.5 3.2 11.7 5 18.1 5 19.7 0 35.6-16 35.6-35.6zm-14 10.2c0.3 0.4 0.3 2.6-0.6 5.1-0.9 2.5-5.2 4.7-7.2 5-1.9 0.3-4.2 0.4-6.8-0.4-1.5-0.5-3.5-1.1-6.1-2.2-10.7-4.7-17.7-15.5-18.2-16.2-0.6-0.7-4.4-5.8-4.4-11.1 0-5.2 2.8-7.8 3.7-8.9 1-1 2.2-1.3 2.9-1.3 0.7 0 1.4 0 2 0 0.7 0.1 1.6-0.2 2.4 1.9 0.9 2.1 3.1 7.4 3.3 7.9 0.3 0.5 0.5 1.2 0.1 1.9-0.3 0.7-0.5 1.1-1 1.8-0.6 0.6-1.2 1.4-1.6 1.8-0.6 0.6-1.1 1.1-0.5 2.2 0.6 1.1 2.8 4.6 5.9 7.4 4.1 3.7 7.6 4.8 8.6 5.3 1.1 0.6 1.7 0.5 2.4-0.2 0.6-0.7 2.6-3.2 3.3-4.2 0.8-1.1 1.5-0.9 2.5-0.6 0.9 0.4 6.2 3 7.3 3.5 1 0.6 1.8 0.8 2 1.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.7123d62437a6f782e6cc63811014a0df.svg";
export { ForwardRef as ReactComponent };